import { useContext } from "react";
import { FormInput } from "best-common-react";
import { EditCustomCardContext } from "../contexts/EditCustomCardContext";
import { CardInfoStyle } from "../common/CardInfoStyle";

const LineupCardInfoSection = () => {
  const editCustomCardContext = useContext(EditCustomCardContext);
  const { dispatch } = editCustomCardContext;
  const { lineupCardInfo } = editCustomCardContext.state;

  return (
    <CardInfoStyle>
      <div className="d-flex">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="home-team-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="Home Team"
            editable={true}
            value={lineupCardInfo.homeTeam}
            onChangeFn={(value) => {
              dispatch({
                type: "setLineupHomeTeam",
                homeTeam: value,
              });
            }}
          />
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <FormInput
            name="away-team-text-input"
            type="text"
            isRequired={false}
            isDisabled={false}
            label="Away Team"
            editable={true}
            value={lineupCardInfo.awayTeam}
            onChangeFn={(value) => {
              dispatch({
                type: "setLineupAwayTeam",
                awayTeam: value,
              });
            }}
          />
        </div>
      </div>
      <div className="col-lg-6 col-md-12 col-sm-12">
        <FormInput
          name="game-date-text-input"
          type="date"
          isRequired={false}
          isDisabled={false}
          label="Date"
          editable={true}
          value={lineupCardInfo.gameDate}
          onChangeFn={(value) => {
            dispatch({
              type: "setLineupDate",
              gameDate: value,
            });
          }}
        />
      </div>
    </CardInfoStyle>
  );
};

export default LineupCardInfoSection;
